/** Shared new-ui marketplace styles for checkout (visual only). */

export const checkoutPage = "min-h-screen bg-[#0F172A]";
export const checkoutContainer = "max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10";
export const checkoutPageTitle =
  "text-2xl sm:text-3xl font-black uppercase tracking-tight text-white mb-2";
export const checkoutEventTitle =
  "text-lg sm:text-xl font-black uppercase tracking-tight text-white/90";
export const checkoutCard = "bg-[#111827] rounded-2xl border border-[#1F2937] p-6";
export const checkoutSectionTitle =
  "text-lg font-black uppercase tracking-tight text-white mb-4";
export const checkoutLabel =
  "mb-2 block text-xs font-bold uppercase tracking-wider text-white/50";
export const checkoutInput =
  "block w-full rounded-xl border border-[#1F2937] bg-[#0F172A] px-3 py-2.5 text-sm text-white placeholder:text-white/30 focus:border-red-600/50 focus:outline-none focus:ring-1 focus:ring-red-600/30 transition-colors";
export const checkoutErrorAlert =
  "mb-6 rounded-xl border border-red-600/40 bg-red-600/10 px-4 py-3 text-sm text-red-400";
export const checkoutSummaryRow =
  "flex items-center justify-between gap-4 py-3 border-b border-[#1F2937] last:border-0";
export const checkoutSummaryLabel = "text-sm text-white/50";
export const checkoutSummaryValue = "text-sm font-medium text-white";
export const checkoutApplyBtn =
  "shrink-0 rounded-xl bg-red-600 px-5 py-2.5 text-sm font-black uppercase tracking-wider text-white hover:bg-red-700 transition-colors disabled:opacity-50";
